export const API_URL = 'https://api.reactbricks.com/v2'
export const GA_ID = 'UA-157966292-2'
